define('models/UniversalLinkModel',['ObjectModel','site_vars'],function (ObjectModel,site_vars) {
    //
    // Model UniversalLink
    //
    var baseURLRegExp = new RegExp('('+site_vars.base_url+')?(/?'+site_vars.country_code.toLowerCase()+')?/?(.*)');

    var UniversalLinkModelPrototype = {
        
        name:'UniversalLinkModel',
        idAttribute:'universal_link',
        toDeeplink:function(url){
            // converti un universal link en deeplink
            var route = url.replace(baseURLRegExp,'/$3');
            var regexp = new RegExp('^'+this.get('universal_link')), deeplink, r = false;
            if(regexp.test(route)){
                deeplink = this.get('deeplink');
                r = route.replace(regexp,'sushishop://'+deeplink);
            }else{
            }
            return r;
        }
    };

    var UniversalLinkModel = ObjectModel.extend(UniversalLinkModelPrototype);
    
    return UniversalLinkModel;
});
